// BottomAgeVerifyBanner.jsx
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import trackMixpanel, {
  EventTypes,
  getViewId,
  ButtonId,
} from '../resource/mixpanel.js';
import ToBottomIconSrc from '../../img/ic-to-down.svg';
import CrossIconSrc from '../../img/img_cross.svg';

export class BottomAgeVerifyBanner extends React.PureComponent {
  nextTick = undefined;
  state = {
    isServer: true,
  };
  componentDidMount() {
    this.nextTick = setTimeout(() => this.setState({ isServer: false }), 0);
  }
  componentWillUnmount() {
    clearTimeout(this.nextTick);
  }
  handleOnClick = () => {
    const { isAuthed, login, openVerifyFreeUserModal } = this.props;
    trackMixpanel({
      type: EventTypes.USER_CLICKED,
      payload: {
        viewId: getViewId({
          pathname: window.location.pathname,
        }),
        buttonId: ButtonId.All.ButtonAgeVerifyBanner,
      },
    });

    if (isAuthed) return openVerifyFreeUserModal();
    else return login();
  };
  render() {
    const { isRemoteConfigMerged, shouldAgeVerify, t, blockerUrl } = this.props;
    const { isServer } = this.state;
    const shouldDisplayBanner =
      !isServer && isRemoteConfigMerged && shouldAgeVerify;
    return shouldDisplayBanner ? (
      <StyledBottomAgeVerifyBanner onClick={this.handleOnClick}>
        <BlockerSection>
          <BlockerImage src={blockerUrl} alt="Blocker" />
          <BlockerCross src={CrossIconSrc} alt="Cross" />
        </BlockerSection>
        <Text>{t('age_verification_application')}</Text>
        <Icon src={ToBottomIconSrc} alt="Verify" />
      </StyledBottomAgeVerifyBanner>
    ) : null;
  }
}

BottomAgeVerifyBanner.propTypes = {
  t: PropTypes.func,
  isAuthed: PropTypes.bool,
  isRemoteConfigMerged: PropTypes.bool,
  shouldAgeVerify: PropTypes.bool,
  openVerifyFreeUserModal: PropTypes.func,
  login: PropTypes.func,
  blockerUrl: PropTypes.string,
};

BottomAgeVerifyBanner.defaultProps = {
  t: () => null,
  isAuthed: false,
  isRemoteConfigMerged: false,
  shouldAgeVerify: false,
  openVerifyFreeUserModal: () => null,
  login: () => null,
  blockerUrl: '',
};

const StyledBottomAgeVerifyBanner = styled.div`
  position: relative;
  width: 100%;
  height: 88px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  background-color: #f5a623;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  cursor: pointer;
  padding: 20px 16px;
`;

const BlockerSection = styled.div`
  position: relative;
  width: 140px;
  height: 88px;
`;

const BlockerImage = styled.img`
  width: 140px;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%);
`;
const BlockerCross = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%);
  width: 84px;
  height: auto;
  z-index: 1;
`;
const Text = styled.div`
  flex: 1;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin: 0 12px;
`;

const Icon = styled.img`
  width: 16px;
  height: 16px;
  transform: rotate(-90deg);
`;
export default withTranslation()(BottomAgeVerifyBanner);
